import { IFormViewForm } from 'components/FormView';

const PrintDialog: IFormViewForm = {
    id: 'PrintForm',
    layout: {
        rows: 1,
        columns: 2
    },
    fields: [
        {
            id: '1',
            type: 'PAPER_CONTAINER',
            visible: true,
            props: {
                name: 'activity',
                fullWidth: true,
                elevation: 0
            },
            position: {
                row: 1,
                col: 1,
                colspan: 3
            },
            children: [
                {
                    id: 1,
                    type: 'DOCUMENT_OUTPUT_FIELD',
                    visible: true,
                    style: {
                        display: 'inline-block',
                        width: '70%',
                    },
                    props: {
                        label: 'Print to printer',
                        name: 'DocumentOutputOptions',
                        size: 'large',
                        isCustomerSupplierScoped: true
                    }
                }
            ]
        }
    ]
};

export default PrintDialog;
